import { useEffect, useState } from "react";
import { Pencil, ShoppingBag } from "lucide-react";
import { WhatsAppGlyph } from "@/components/cards/CardShell";
import { fetchMyCarts, ron } from "@/lib/bf";
import { waLink } from "@/lib/wa";

const ago = (iso) => {
  const h = (Date.now() - new Date(iso).getTime()) / 36e5;
  return h < 1 ? `acum ${Math.max(1, Math.round(h * 60))} min` : h < 48 ? `acum ${Math.round(h)} h` : `acum ${Math.round(h / 24)} zile`;
};

export default function BFCarts({ cfg }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { fetchMyCarts().then(setRows).catch(() => setRows([])); }, []);
  if (!rows) return null;
  return (
    <div className="bf-carts" data-testid="bf-carts">
      <div className="st-section-title"><ShoppingBag size={12} /> Coșuri începute, netrimise ({rows.length})</div>
      {!rows.length && <p className="st-hint" data-testid="bf-carts-empty">Niciun salon nu are acum un coș netrimis. Dacă un salon lasă coșul mai mult de 2 ore, primești un e-mail și îl vezi aici.</p>}
      <ul>
        {rows.map((c) => (
          <li key={c.lead} data-testid={`bf-cart-row-${c.lead}`}>
            <div>
              <b>{c.salon || "Salon"}</b>
              <small>{c.phone} · {c.pieces} buc. · {ago(c.updated_at)}{c.reminded_at ? " · e-mail trimis" : ""}</small>
            </div>
            <strong>{ron(c.total)}</strong>
            <a className="st-btn st-btn--light" href={`${window.location.origin}/blackfriday?edit=${c.lead}${cfg?.preview_token ? `&preview=${cfg.preview_token}` : ""}`} data-testid={`bf-cart-open-${c.lead}`}><Pencil size={14} /> Deschide și modifică</a>
            {c.phone && waLink(c.phone, `Bună ziua! Văd că ați început o comandă Black Friday Beauty Trends (${ron(c.total)}). Vă pot ajuta să o finalizați?`) && <a className="st-btn st-btn--ghost" href={waLink(c.phone, `Bună ziua! Văd că ați început o comandă Black Friday Beauty Trends (${ron(c.total)}). Vă pot ajuta să o finalizați?`)} target="_blank" rel="noopener noreferrer" data-testid={`bf-cart-wa-${c.lead}`}><WhatsAppGlyph /> Scrie-i</a>}
          </li>
        ))}
      </ul>
    </div>
  );
}
